import { Box, Text } from '@mantine/core'

import clsx from '@/utils/clsx'

import styles from '../index.module.css'

interface TimeRangeItemProps {
  isActive: boolean
  value: string
  label: string
  onClick: (value: string) => void
}

export default function TimeRangeItem({ isActive, value, label, onClick }: TimeRangeItemProps) {
  return (
    <Box
      className={clsx({
        [styles.timeRangeItem]: true,
        [styles.timeRangeItemActive]: isActive,
      })}
      onClick={() => {
        onClick(value)
      }}
    >
      <Text variant={'subtitle'}>{label}</Text>
    </Box>
  )
}
